<template>
  <el-dialog :title="`设置权限：${roleName}`" :visible="visible" width="600px" :close-on-click-modal="false"
    @close="$emit('update:visible', false)">
    <div class="permission-container">
      <div class="permission-header">
        <span>菜单权限</span>
        <el-checkbox v-model="expandAll" @change="handleExpandChange">展开/折叠</el-checkbox>
        <el-checkbox v-model="selectAll" @change="handleSelectAll">全选/全不选</el-checkbox>
      </div>

      <div class="permission-tree">
        <!-- 增加key强制刷新树组件 -->
        <el-tree ref="menuTree" :data="menuList" show-checkbox node-key="id" :expand-on-click-node="false"
          v-model="checkedKeys" :key="treeKey" :check-strictly="true">
          <template slot-scope="{ node }">
            <span class="node-label" :class="{ 'checked': node.checked }">
              {{ node.label }}
            </span>
          </template>
        </el-tree>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'PermissionDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    roleName: {
      type: String,
      default: ''
    },
    menuList: {
      type: Array,
      default: () => []
    },
    roleMenus: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      expandAll: true,
      selectAll: false,
      parentChildLink: true,
      checkedKeys: [],
      treeKey: 0 // 用于强制刷新树组件的key
    }
  },
  watch: {
    // 每次弹窗显示时重新初始化
    visible(newVal) {
      if (newVal) {
        // 延迟确保DOM完全渲染
        setTimeout(() => {
          this.initTreeState();
          // 设置角色已有的菜单权限
          this.setRoleMenus();
        }, 100);
      }
    },
    // 监听展开状态变化，强制刷新
    expandAll(newVal) {
      this.treeKey += 1; // 改变key强制刷新树
      setTimeout(() => {
        this.setTreeExpandState(newVal);
      }, 50);
    },
    // 监听角色菜单权限变化
    roleMenus(newVal) {
      console.log('角色菜单权限变化:', newVal);
      // 当角色菜单权限变化时，设置默认选中的菜单
      if (this.visible) {
        this.setRoleMenus();
      }
    }
  },
  methods: {
    // 初始化树状态
    initTreeState() {
      this.setTreeExpandState(this.expandAll);
    },

    // 设置角色已有的菜单权限
    setRoleMenus() {
      const tree = this.$refs.menuTree;
      if (tree) {
        console.log('设置角色已有的菜单权限:', this.roleMenus);
        // 使用tree.setCheckedKeys方法设置默认选中的菜单
        tree.setCheckedKeys(this.roleMenus);
        // 更新checkedKeys数据
        this.checkedKeys = this.roleMenus;
        console.log('已设置默认选中的菜单');
      } else {
        console.warn('树组件未找到，无法设置角色菜单权限');
      }
    },

    // 核心：设置树展开/折叠状态（直接操作DOM+组件实例）
    setTreeExpandState(isExpand) {
      const tree = this.$refs.menuTree;
      if (!tree) return;

      // 方案1：直接操作DOM点击展开/折叠按钮（最暴力但最有效）
      const expandIcons = document.querySelectorAll('.permission-tree .el-tree-node__expand-icon');
      expandIcons.forEach(icon => {
        // 判断当前状态：折叠状态是 el-icon-caret-right，展开是 el-icon-caret-bottom
        const isCollapsed = icon.classList.contains('el-icon-caret-right');
        const isExpanded = icon.classList.contains('el-icon-caret-bottom');

        // 需要展开且当前折叠 → 点击
        if (isExpand && isCollapsed) {
          icon.click();
        }
        // 需要折叠且当前展开 → 点击
        else if (!isExpand && isExpanded) {
          icon.click();
        }
      });

      // 方案2：备用 - 递归设置节点状态（双保险）
      const setNodeState = (node, state) => {
        if (node) {
          node.expanded = state;
          if (node.childNodes) {
            node.childNodes.forEach(child => setNodeState(child, state));
          }
        }
      };

      if (tree.store && tree.store.root) {
        // 遍历所有层级节点
        const rootNodes = tree.store.root.childNodes || [];
        rootNodes.forEach(node => setNodeState(node, isExpand));
      }
    },

    // 处理展开/折叠切换
    handleExpandChange(val) {
      this.expandAll = val;
    },

    // 处理全选/全不选
    handleSelectAll(val) {
      this.selectAll = val;
      const tree = this.$refs.menuTree;
      if (!tree) return;

      if (val) {
        const allKeys = this.getAllNodeKeys(this.menuList);
        tree.setCheckedKeys(allKeys);
      } else {
        tree.setCheckedKeys([]);
      }
    },

    // 递归获取所有节点key
    getAllNodeKeys(nodes) {
      let keys = [];
      nodes.forEach(node => {
        keys.push(node.id);
        if (node.children && node.children.length) {
          keys = keys.concat(this.getAllNodeKeys(node.children));
        }
      });
      return keys;
    },

    // 提交
    handleSubmit() {
      // 使用tree组件的getCheckedKeys方法获取所有选中的菜单ID
      const tree = this.$refs.menuTree;
      let checkedKeys = [];
      if (tree) {
        checkedKeys = tree.getCheckedKeys(false); // false表示不包含半选节点，只获取完全选中的节点
        console.log('通过getCheckedKeys获取的选中菜单ID:', checkedKeys);
      } else {
        checkedKeys = this.checkedKeys;
        console.log('通过v-model获取的选中菜单ID:', checkedKeys);
      }

      // 确保包含所有子菜单的父级菜单ID
      const allCheckedKeys = this.ensureParentMenus(checkedKeys);
      console.log('包含父级菜单ID的选中菜单:', allCheckedKeys);

      this.$emit('submit', {
        checkedKeys: allCheckedKeys,
        parentChildLink: this.parentChildLink
      });
      this.$emit('update:visible', false);
    },

    // 确保包含所有子菜单的父级菜单ID
    ensureParentMenus(checkedKeys) {
      const allKeys = [...checkedKeys];

      // 递归查找父级菜单
      const findParentMenus = (node, targetId) => {
        if (node.id === targetId) {
          return [node.id];
        }
        if (node.children && node.children.length > 0) {
          for (const child of node.children) {
            const parents = findParentMenus(child, targetId);
            if (parents.length > 0) {
              return [node.id, ...parents];
            }
          }
        }
        return [];
      };

      // 对每个选中的菜单，确保其父级菜单也被选中
      for (const key of checkedKeys) {
        for (const menu of this.menuList) {
          const parents = findParentMenus(menu, key);
          if (parents.length > 0) {
            for (const parentId of parents) {
              if (!allKeys.includes(parentId)) {
                allKeys.push(parentId);
              }
            }
          }
        }
      }

      return allKeys;
    }
  }
}
</script>

<style scoped>
.permission-container {
  margin-top: 20px;
}

.permission-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  font-size: 14px;
}

.permission-header span {
  margin-right: 20px;
}

.permission-header .el-checkbox {
  margin-right: 20px;
}

.permission-tree {
  max-height: 400px;
  overflow-y: auto;
}

.node-label {
  font-size: 14px;
}

.node-label.checked {
  color: #1890ff;
  font-weight: bold;
}

::v-deep .permission-tree .el-tree-node.is-checked .el-checkbox__inner {
  /* background-color: #1890ff !important;
  border-color: #1890ff !important; */
}

::v-deep .permission-tree .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #1890ff !important;
  border-color: #1890ff !important;
}
</style>